import React, { FC } from 'react';

import { Button, Grid, Stack, Typography } from '@mui/material';
import { TwitterLogo } from 'phosphor-react';

import { NormalLink } from '~components/shared/link';
import { primaryColors } from '~components/theme/styles/colors';

import SlideWrapper from '../SlideWrapper';

const VIP_SHILL_LIST: { person: string; href: string }[] = [
  { person: 'TETRANODE', href: '' },
  { person: 'DCFGOD', href: '' },
  { person: 'FISKANTES', href: '' },
  { person: 'NOT3LAU CAPITAL', href: '' },
  { person: 'SAM KAZEMIAN@FRAX', href: '' },
  { person: 'OXMONS@SUDOSWAP', href: '' },
  { person: 'MARIANO CONTI', href: '' },
  { person: 'FISHERS CAPITAL', href: '' },
  { person: 'ANGELDAO', href: '' },
];

const SupportedBySlide: FC = () => {
  return (
    <SlideWrapper>
      <Stack spacing={8}>
        <Typography variant={'h4'} color={primaryColors[50]}>
          Supported by the best
        </Typography>
        <Typography variant={'body1'} color={primaryColors[400]}>
          Not to namedrop but, some heavy players are around
        </Typography>
      </Stack>
      <Grid container direction={'row'} justifyContent={'space-between'} spacing={4} mt={8}>
        {VIP_SHILL_LIST.map(({ person, href }) => (
          <Grid item xs={12} sm={6} md={4} key={person}>
            <NormalLink sx={{ textDecoration: 'none' }} href={href} target={'_blank'}>
              <Button variant={'primary'} fullWidth>
                <Stack direction={'row'} spacing={2} alignItems={'center'} textAlign={'start'} width={'100%'}>
                  <TwitterLogo size={16} color={primaryColors[400]} />
                  <Typography
                    variant={'label2'}
                    sx={{
                      background:
                        'linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF',
                      backgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {person}
                  </Typography>
                </Stack>
              </Button>
            </NormalLink>
          </Grid>
        ))}
      </Grid>
      <Typography variant={'body1'} color={primaryColors[400]} mt={8}>
        And more...
      </Typography>
    </SlideWrapper>
  );
};

export default SupportedBySlide;
